/*!
 * Bloom Multimedia ©
 * https://www.bloom-multimedia.fr/
 *
 * Date: 2021-09-28
 */

window.dataLayer = window.dataLayer || [];

interface CustomListener {
  name: string;
  target: string;
  cbk: any;
}

class Manager {
  addAllBtn!: HTMLCollection;
  deleteAllBtn!: HTMLCollection;
  // deleteAllBtn!: HTMLElement | null;
  addBtnPub!: HTMLElement | null;
  removeBtnPub!: HTMLElement | null;
  addBtnAudience!: HTMLElement | null;
  removeBtnAudience!: HTMLElement | null;
  addBtnPerf!: HTMLElement | null;
  removeBtnPerf!: HTMLElement | null;
  showCookiePanel!: HTMLCollection;
  hideCookiePanel!: HTMLElement | null;
  validCookiePanel!: HTMLElement | null;
  cancelCookiePanel!: HTMLElement | null;
  pubEnabled!: boolean | null;
  fonctEnabled!: boolean | null;
  perfEnabled!: boolean | null;
  forceInteraction!: boolean | true;

  initCookies() {
    this.initAllBtn();
    const bandeau = document.getElementById("bandeau-cookie");

    if (bandeau) {
      const bandeauCookieLink = bandeau.getElementsByClassName("cookie-link"),
        bandeauBtnWrapper = bandeau.getElementsByClassName("wrapper-btn");
      if (bandeauBtnWrapper && bandeauBtnWrapper.length > 0) {
        Object.values(bandeauBtnWrapper).forEach((e) => {
          e.classList.add(
            bandeauCookieLink && bandeauCookieLink.length > 0
              ? "multi-line"
              : "one-line"
          );
        });
      }
    }

    if (!this.checkAlertBoxClosed()) {
      if (bandeau != null) {
        bandeau.style.display = "block";
      }
      if (this.forceInteraction) {
        this.showCookieBackdrop();
      }
    }

    if (!this.checkBMCookie()) {
      // Check du CookieBM si il n'existe pas, on le crée
      if (!this.forceInteraction) {
        this.createBMCookie();
      }
    } else {
      //si il existe on le récupère et on isole les groupes
      const groups = this.recoverGroupsCookieBM().join(",");

      // et on envoie les gtm event suivant les groupes existants
      this.pubEnabled = groups.includes("C0004");
      this.fonctEnabled = groups.includes("C0003");
      this.perfEnabled = groups.includes("C0002");

      this.callTagManager(
        "maj-cookie",
        this.perfEnabled,
        this.fonctEnabled,
        this.pubEnabled
      );
    }

    if (!this.forceInteraction) {
      this.hideCookieBackdrop();
    }
  }

  addCookie(nameCookie: string) {
    const d = new Date();
    const value = encodeURIComponent(d.toISOString()).replace(/%3A/g, ":");
    const regexAvecSousDomaine = /((\w|-)+\.\w+)$/;
    let domain = location.hostname;
    if (domain.split(".").length > 2) {
      domain = domain.match(regexAvecSousDomaine)[1];
    }
    this.setCookie(nameCookie, value, undefined, domain);
  }

  checkBMCookie() {
    //Récupération du cookie
    const cookieBM = document.cookie
      .split(";")
      .map((cookie) => cookie.trim())
      .filter((cookie) => {
        return (
          cookie.substring(0, "Consentements".length + 1) ==
          `${"Consentements"}=`
        );
      });

    return cookieBM.length > 0;
  }

  checkAlertBoxClosed() {
    //Récupération du cookie
    const cookieBM = document.cookie
      .split(";")
      .map((cookie) => cookie.trim())
      .filter((cookie) => {
        return (
          cookie.substring(0, "InteractionBandeau".length + 1) ==
          `${"InteractionBandeau"}=`
        );
      });

    return cookieBM.length > 0;
  }

  createBMCookie(groups = "C0001:1,C0004:0,C0003:0,C0002:0") {
    // Ex du cookie : datestamp=Tue+Aug+25+2020+15%3A00%3A44+GMT%2B0200+(heure+d%E2%80%99%C3%A9t%C3%A9+d%E2%80%99Europe+centrale)
    // &groups=C0001%3A1%2CC0004%3A1%2CC0003%3A1%2CC0002%3A1&hosts=

    const value =
      "datestamp=" +
      encodeURIComponent(new Date().toISOString()).replace(/%20/g, "+") +
      "&groups=" +
      encodeURIComponent(groups) +
      "&hosts=";
    const regexAvecSousDomaine = /((\w|-)+\.\w+)$/;
    let domain = location.hostname;
    if (domain.split(".").length > 2) {
      domain = domain.match(regexAvecSousDomaine)[1];
    }
    this.setCookie("Consentements", value, undefined, domain);
  }

  recoverGroupsCookieBM() {
    //Récupération des groupes actifs dans le cookie BM sous forme d'array

    //Groupes :
    //    - C0001 : Cookies strictement nécessaires
    //    - C0004 : Cookies pour une publicité ciblée
    //    - C0003 : Cookies de fonctionnalité
    //    - C0002 : Cookies de performance

    const cookie_string = this.getCookie("Consentements");
    if (typeof cookie_string !== "boolean") {
      const pos = cookie_string.indexOf("groups");

      const groups = decodeURIComponent(
        cookie_string.substring(pos + 7, pos + 52)
      );

      return groups
        .split(",")
        .filter((group) => {
          return group.indexOf(":1") > 0;
        })
        .map((group) => group.substring(0, 5));
    }

    return [];
  }

  checkForToggle(className: string) {
    const nbBtnCookieHandlerModal = document.getElementsByClassName(
      "btnCookieHandlerModal"
    )
      ? document.getElementsByClassName("btnCookieHandlerModal").length / 2
      : 3;
    return (
      document.querySelectorAll("." + className + ".selected").length ===
      nbBtnCookieHandlerModal
    );
  }

  updateClassSelected(item: HTMLElement | Element | null, added: boolean) {
    if (item) {
      if (added) {
        item.classList.add("selected");
      } else {
        item.classList.remove("selected");
      }
    }
  }

  toggleBtns(allowed: boolean) {
    const alloweds: HTMLCollectionOf<Element> | boolean = allowed
      ? document.getElementsByClassName("plus")
      : document.getElementsByClassName("minus");
    const unalloweds: HTMLCollectionOf<Element> | boolean = allowed
      ? document.getElementsByClassName("minus")
      : document.getElementsByClassName("plus");
    Object.keys(alloweds).forEach((i) => {
      this.updateClassSelected(alloweds[Number.parseInt(i)], true);
    });

    Object.keys(unalloweds).forEach((i) => {
      this.updateClassSelected(unalloweds[Number.parseInt(i)], false);
    });
  }

  initAllBtn() {
    this.addAllBtn = document.getElementsByClassName("addAll");
    this.deleteAllBtn = document.getElementsByClassName("deleteAll");
    this.validCookiePanel = document.querySelector("#acceptBtn");
    if (this.addAllBtn.length > 0) {
      Object.keys(this.addAllBtn).forEach((key) => {
        this.addAllBtn[Number.parseInt(key)].addEventListener("click", () => {
          if (!this.checkBMCookie()) {
            // Check du CookieBM si il n'existe pas, on le crée
            this.createBMCookie();
          }
          if (this.validCookiePanel) {
            this.validCookiePanel.removeAttribute("disabled");
          }
          this.toggleBtns(true);
          if (/Bandeau/.test(this.addAllBtn[Number.parseInt(key)].id)) {
            this.callTagManager("maj-cookie", true, true, true);
            this.addCookie("InteractionBandeau");
            if (this.forceInteraction) {
              this.hideCookieBackdrop();
            }
          }
        });
      });
    }
    if (this.deleteAllBtn.length > 0) {
      Object.keys(this.deleteAllBtn).forEach((key) => {
        this.deleteAllBtn[Number.parseInt(key)].addEventListener(
          "click",
          () => {
            if (!this.checkBMCookie()) {
              // Check du CookieBM si il n'existe pas, on le crée
              this.createBMCookie();
            }
            if (this.validCookiePanel) {
              this.validCookiePanel.removeAttribute("disabled");
            }
            this.toggleBtns(false);
            if (/Bandeau/.test(this.deleteAllBtn[Number.parseInt(key)].id)) {
              this.callTagManager("maj-cookie", false, false, false);
              this.addCookie("InteractionBandeau");
              if (this.forceInteraction) {
                this.hideCookieBackdrop();
              }
            }
          }
        );
      });
    }

    const pub = this.recoverGroupsCookieBM().includes("C0004");
    const fonct = this.recoverGroupsCookieBM().includes("C0003");
    const perf = this.recoverGroupsCookieBM().includes("C0002");
    const btns = document.getElementsByClassName("btnCookieHandler");
    const btnsInModal = document.getElementsByClassName(
      "btnCookieHandlerModal"
    );
    const bandeauCookie = document.getElementById("bandeau-cookie");

    Object.keys(btns).forEach((index) => {
      btns[Number.parseInt(index)].addEventListener("click", (e: Event) => {
        if (this.checkBMCookie() && bandeauCookie) {
          bandeauCookie.style.display = "none";
        }
        const el: HTMLInputElement = <HTMLInputElement>e.target;
        if (el.classList && !el.classList.contains("selected")) {
          this.updateClassSelected(btns[Number.parseInt(index)], true);
          if (btns[Number.parseInt(index)].classList.contains("plus")) {
            this.updateClassSelected(
              document.getElementById(
                btns[Number.parseInt(index)].id.replace(/add/, "remove")
              ),
              false
            );
            if (this.checkForToggle("plus")) {
              this.toggleBtns(true);
            } else {
              this.updateClassSelected(
                document.getElementById("deleteAllBtn"),
                false
              );
            }
          } else {
            this.updateClassSelected(
              document.getElementById(
                btns[Number.parseInt(index)].id.replace(/remove/, "add")
              ),
              false
            );
            if (this.checkForToggle("minus")) {
              this.toggleBtns(false);
            } else {
              Object.keys(document.getElementsByClassName("addAll")).forEach(
                (i) => {
                  this.updateClassSelected(
                    document.getElementsByClassName("addAll")[
                    Number.parseInt(i)
                    ],
                    false
                  );
                }
              );
            }
          }
        }

        if (
          document.getElementsByClassName("selected").length >=
          btnsInModal.length / 2 &&
          this.validCookiePanel
        ) {
          this.validCookiePanel.removeAttribute("disabled");
        }
      });
      // Gestion des boutons pour tous
      if (/All/.test(btns[Number.parseInt(index)].id)) {
        if (this.checkAlertBoxClosed() && !this.forceInteraction) {
          this.updateClassSelected(
            btns[Number.parseInt(index)],
            pub &&
              fonct &&
              perf &&
              btns[Number.parseInt(index)].classList.contains("addAll")
              ? true
              : !pub &&
              !fonct &&
              !perf &&
              btns[Number.parseInt(index)].classList.contains("minus")
          );
        }
      } else {
        if (this.checkAlertBoxClosed() && !this.forceInteraction) {
          if (/Pub/.test(btns[Number.parseInt(index)].id)) {
            if (
              btns[Number.parseInt(index)].classList.contains("plus") &&
              fonct
            ) {
              this.updateClassSelected(btns[Number.parseInt(index)], true);
            }
            if (
              btns[Number.parseInt(index)].classList.contains("minus") &&
              !fonct
            ) {
              this.updateClassSelected(btns[Number.parseInt(index)], true);
            }
          } else if (/Perf/.test(btns[Number.parseInt(index)].id)) {
            if (
              btns[Number.parseInt(index)].classList.contains("plus") &&
              perf
            ) {
              this.updateClassSelected(btns[Number.parseInt(index)], true);
            }
            if (
              btns[Number.parseInt(index)].classList.contains("minus") &&
              !perf
            ) {
              this.updateClassSelected(btns[Number.parseInt(index)], true);
            }
          } else if (/Audience/.test(btns[Number.parseInt(index)].id)) {
            if (
              btns[Number.parseInt(index)].classList.contains("plus") &&
              pub
            ) {
              this.updateClassSelected(btns[Number.parseInt(index)], true);
            }
            if (
              btns[Number.parseInt(index)].classList.contains("minus") &&
              !pub
            ) {
              this.updateClassSelected(btns[Number.parseInt(index)], true);
            }
          }
        }
      }

      // if (!this.forceInteraction && this.validCookiePanel) {
      //     this.validCookiePanel.removeAttribute("disabled");
      // }
    });
  }

  cookiePanel(event: string) {
    const panel = document.getElementById("cookiePanel");

    if (event === "show" && panel !== null) {
      this.show();
      this.showCookieBackdrop();
    }

    if (event === "hide" && panel !== null) {
      this.hide();
      if (!this.forceInteraction) {
        this.hideCookieBackdrop();
      }
    }
  }

  showCookieBackdrop() {
    const body = document.body,
      el = document.createElement("div");
    el.classList.add("cookie-backdrop");
    this.hideCookieBackdrop();
    el.id = "cookie-backdrop";
    body.appendChild(el);
    body.classList.add("cookie-open");
    el.className += " fade show";
  }

  hideCookieBackdrop() {
    const backdrop = document.getElementById("cookie-backdrop"),
      body = document.body;
    if (backdrop !== null && backdrop.parentNode) {
      backdrop.parentNode.removeChild(backdrop);
    }
    body.classList.remove("cookie-open");
  }

  show() {
    const body = document.body,
      panel = document.getElementById("cookiePanel"),
      bandeau = document.getElementById("bandeau-cookie");
    if (panel) {
      panel.style.display = "block";
      panel.onclick = (e: Event) => {
        if (e.target) {
          const targetId = (<HTMLInputElement>e.target).id;
          if (targetId === "cookiePanel") {
            this.hide();
          }
        }
      };
    }
    setTimeout(() => {
      if (panel !== null) {
        panel.classList.add("show");
      }
    }, 0);
    body.classList.add("cookie-open");
    if (bandeau !== null) {
      bandeau.style.display = "none";
    }
  }

  hide() {
    const body = document.body,
      panel = document.getElementById("cookiePanel"),
      bandeau = document.getElementById("bandeau-cookie");
    if (panel !== null) {
      panel.classList.remove("show");
    }
    setTimeout(() => {
      if (panel !== null) {
        panel.style.display = "none";
      }
      body.classList.remove("cookie-open");

      if (!this.checkBMCookie() && !this.checkAlertBoxClosed()) {
        if (bandeau !== null) {
          bandeau.style.display = "block";
          if (this.forceInteraction) {
            this.showCookieBackdrop();
          }
        }
      }

      if (!this.checkAlertBoxClosed() && bandeau !== null) {
        bandeau.style.display = "block";
        body.classList.add("cookie-open");
      }

      if (this.checkAlertBoxClosed() && bandeau !== null) {
        if (this.forceInteraction) {
          this.hideCookieBackdrop();
        }
        bandeau.style.display = "none";
        body.classList.remove("cookie-open");
      }

      if (!this.forceInteraction) {
        this.hideCookieBackdrop();
      }
    }, 100);
  }

  /**
   * Permet de check si un cookie existe, renvoie true ou false
   *
   * @param cookieName
   * @return boolean
   */
  checkCookie(cookieName: string) {
    const cookie = this.getCookie(cookieName);

    return !!cookie;
  }

  callTagManager(
    nom: string,
    perfEnabled: null | boolean,
    fonctEnabled: null | boolean,
    pubEnabled: null | boolean
  ) {
    //{"event": "maj-cookie", "performance": perfEnabled, "fonctionnalite": fonctEnabled, "publicite": pubEnabled}
    window.dataLayer.push({
      event: nom,
      performance: perfEnabled,
      fonctionnalite: fonctEnabled,
      publicite: pubEnabled,
    });
  }

  /**
   * @param cname
   * @returns string|false
   */
  getCookie(cname: string) {
    const name = cname + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return false;
  }

  setCookie(cname: string, cvalue: string, exdays = 365, domain = "") {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie =
      cname +
      "=" +
      cvalue +
      ";" +
      expires +
      ";" +
      "domain=" +
      domain +
      ";path=/;samesite=lax";
  }

  addListener(listeners: CustomListener[]) {
    listeners.forEach((listener: CustomListener) => {
      if (listener.target !== null) {
        document.querySelectorAll(listener.target).forEach((target) => {
          target.addEventListener(listener.name, listener.cbk.bind(this));
        });
      } else {
        window.addEventListener(listener.name, listener.cbk.bind(this));
      }
    });
  }

  public listenToScroll(scrollTrigger = screen.height * 1.2) {
    const scrollPos = window.pageYOffset || document.documentElement.scrollTop,
      bandeauCookie = document.getElementById("bandeau-cookie"),
      cookiesPercentage = document.getElementById("cookiesPercentage");

    if (bandeauCookie !== null) {
      if (bandeauCookie.style.display === "block") {
        if (scrollPos > scrollTrigger) {
          this.toggleBtns(true);
          bandeauCookie.style.display = "none";
        }
        if (cookiesPercentage) {
          cookiesPercentage.style.width =
            (100 / scrollTrigger) * scrollPos + "%";
        }
      }
    }
    return scrollPos > scrollTrigger;
  }
}

export default new Manager();
